var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMinuHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 19.728,
    viewBox: "0 0 100 19.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4235",
    "data-name": "Rect\\xE1ngulo 4235",
    width: 100,
    height: 19.728,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22148",
    "data-name": "Grupo 22148",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22147",
    "data-name": "Grupo 22147",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24544",
    "data-name": "Trazado 24544",
    d: "M83.086,41.129H78.848c0-.264,0-.513,0-.762-.035-2.008-.018-4.02-.127-6.024-.066-1.209-.638-1.751-1.569-1.795a1.864,1.864,0,0,0-2.079,1.7,7.964,7.964,0,0,0-.14,1.479c-.016,1.771-.006,3.542-.006,5.368H70.6c0-.333,0-.653,0-.972-.015-1.859.005-3.719-.059-5.576-.049-1.419-.618-2.061-1.7-2.111a1.667,1.667,0,0,0-1.887,1.325,8.478,8.478,0,0,0-.214,1.921c-.027,1.79-.009,3.581-.009,5.42H62.417V29.13h4.3V30.7c2.795-2.423,5.555-2.155,8.157.67.131-.168.258-.333.388-.5a4.861,4.861,0,0,1,5.741-1.375,3.413,3.413,0,0,1,2.047,3.092c.109,2.822.033,5.652.033,8.543",
    transform: "translate(-46.106 -21.456)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24545",
    "data-name": "Trazado 24545",
    d: "M212.919,41.217h-4.306c-.013-.233-.034-.459-.035-.685,0-1.556,0-3.113,0-4.669,0-.41,0-.823-.043-1.231a1.892,1.892,0,0,0-1.843-1.965A2.094,2.094,0,0,0,204.3,34.38a5.428,5.428,0,0,0-.1,1.156c-.01,1.875,0,3.751,0,5.663h-4.352V29.23h4.329v1.726c.3-.27.463-.419.627-.57a5.425,5.425,0,0,1,6.9.039,3.41,3.41,0,0,1,1.2,2.438c.046,2.762.016,5.526.016,8.354",
    transform: "translate(-147.621 -21.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24546",
    "data-name": "Trazado 24546",
    d: "M269.836,29.353h4.247c.012.267.033.52.034.773,0,1.751-.007,3.5,0,5.253.012,1.857,1.117,2.731,2.931,2.337a1.963,1.963,0,0,0,1.533-2.183c.019-1.816.007-3.632.008-5.447,0-.232,0-.463,0-.734h4.341c.01.224.029.452.029.68q0,2.95,0,5.9c0,3.083-1.259,4.667-4.265,5.239a11.591,11.591,0,0,1-5.709-.254,4.125,4.125,0,0,1-3.185-3.963c-.1-2.46-.039-4.927-.046-7.39a.8.8,0,0,1,.075-.211",
    transform: "translate(-199.259 -21.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4234",
    "data-name": "Rect\\xE1ngulo 4234",
    width: 4.396,
    height: 12.144,
    transform: "translate(42.438 7.512)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24547",
    "data-name": "Trazado 24547",
    d: "M8.016,35.595,2.388,41.478c-2.92-2.574-3.423-8.4-.041-11.786l5.669,5.9",
    transform: "translate(0 -21.933)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24548",
    "data-name": "Trazado 24548",
    d: "M352,35.574l5.628-5.883c2.92,2.574,3.423,8.4.041,11.786L352,35.574",
    transform: "translate(-260.014 -21.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24549",
    "data-name": "Trazado 24549",
    d: "M161.115,2.465a2.5,2.5,0,0,1,5,.073,2.5,2.5,0,0,1-5-.073",
    transform: "translate(-119.013 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMinuHome);
export default __webpack_public_path__ + "static/media/Logo_Minu_Home.4ee10aa162f56c4410df7b040aff322e.svg";
export { ForwardRef as ReactComponent };